import React, { Component } from 'react';
import '../../css/App.css';
import { observer } from 'mobx-react';
import {toJS} from 'mobx'
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Input from '@material-ui/core/Input';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import appStore from '../../store/AppStore'
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash'


const styles = {   
  card:{
    marginTop: "15px",    
  },  
  cardheadertext:{
    fontSize: "18px",
    fontFamily: 'Noto Sans TC, sans-serif'
  },
  cardcontent:{
    paddingTop: "0px",    
  }, 
  select:{
    marginRight: "10px",
    marginBottom: "10px"
  }, 
  input:{
    fontFamily: 'Noto Sans TC, sans-serif',    
  }

}



class Address extends Component { 

  handleChange=(objectKey)=>(e)=>{
      appStore.setTextFieldValue(e.target.value, objectKey);
      
  }

  handleZipChange=(type)=>(e)=>{
    appStore.setZipSelectedValue(e.target.value, type)
  }

  render() {
    const { classes, title ,objectKey} = this.props;
    
    
    return (   
          <React.Fragment>
          <CardHeader
            title={<Typography className={classes.cardheadertext}>{title}</Typography>}           
            className={classes.cardheader}
          />
          <CardContent
            className={classes.cardcontent}
          >          
          <Select
            value={appStore.zipSelectedCity}
            onChange={this.handleZipChange('city')}
            className={classes.select}
            inputProps={{
              name: 'city',
              id: 'city',
            }}
          >
          {_.map(appStore.zipSelections, (item, key)=>{  
            return<MenuItem value={item.City} key={key}>{item.City}</MenuItem>
          })}           
          </Select> 

          <Select
            value={appStore.postData.txtZip}
            onChange={this.handleZipChange('zip')}
            className={classes.select}
            inputProps={{
              name: 'zip',
              id: 'zip',
            }}
          >
          {_.map(_.get(_.filter(appStore.zipSelections, (o)=>{ return o.City == appStore.zipSelectedCity})[0], 'Citys'), (item, key)=>{ 
            return<MenuItem value={item.ZipCode} key={key}>{item.District}</MenuItem>
          })} 
          </Select> 
          <Input
              placeholder={'請輸入地址'}
              className={classes.input}              
              onChange={this.handleChange(objectKey)}     
              value={appStore.postData[objectKey]}  
              fullWidth={true}                
            />
          </CardContent>  
          </React.Fragment>      
        
    );
  }
}

export default withStyles(styles)(observer(Address));
